import UserList from '../components/user/UserList';
import { useApp } from '../context/AppContext';
import TaskModal from '../components/task/TaskModal';

import { PageTitle } from '../../../../_metronic/layout/core';

export default function UsersPage() {
  const { state, dispatch } = useApp();
  const selectedTask = state.tasks.find(t => t.id === state.selectedTaskId);

  return (
    <>
      <PageTitle>DevOps - Gerenciamento de Usuários</PageTitle>
      <UserList />
      {selectedTask && (
        <TaskModal
          task={selectedTask}
          onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
        />
      )}
    </>
  );
}
